import { RefObject, useCallback, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { FormInstance } from 'antd/lib/form';

import { RootState } from '@share/utils';
import { insuranceActions, setCard } from '@store/slices';
import { ICardBooking } from '@common-types';
import { PaymentMethodBase } from '@components';
import { IUserCard } from '@share/common-types';

import type { IMultiplePayments } from '../types';

import './style.scss';
import { NULL_VALUE } from '@constants';

export interface IPaymentMethodProps {
  formRef: RefObject<FormInstance>;
  isRequired: boolean;
  display: boolean;
  onChangeCountryState: () => void;
  multiplePayments?: IMultiplePayments;
  setPaymentSelected?: (payment: string) => void;
  paymentSelected?: string;
  handlePaymentFormValidation?: any;
  scrollToPaymentSelect?: boolean;
  scrollToPaymentSelectDisabled?: () => void;
  stripeExpressCheckoutActive?: boolean;
}

export function PaymentMethod(props: IPaymentMethodProps) {
  const dispatch = useDispatch();
  const reviewBookStore = useSelector((state: RootState) => state.reviewBookStore);
  const menuStore = useSelector((state: RootState) => state.navigationMenuStore);
  const loginStore = useSelector((state: RootState) => state.loginStore);

  const [refreshPayment, setRefreshPayment] = useState(false);

  const handleCardSelect = useCallback(
    (selectedCard: IUserCard) => {
      dispatch(setCard(selectedCard as ICardBooking));
      setRefreshPayment(true);
      dispatch(insuranceActions.setSelection(NULL_VALUE));
    },
    [dispatch],
  );

  const onDataRefreshed = useCallback(() => {
    setRefreshPayment(false);
  }, []);

  const {
    isRequired,
    formRef,
    display,
    onChangeCountryState,
    multiplePayments,
    setPaymentSelected,
    paymentSelected,
    handlePaymentFormValidation,
    scrollToPaymentSelect,
    scrollToPaymentSelectDisabled,
    stripeExpressCheckoutActive,
  } = props;

  const { card, errorsField, loadingBooking } = reviewBookStore;
  const { account } = loginStore;
  const { items } = menuStore;

  return (
    <PaymentMethodBase
      form={NULL_VALUE}
      formRef={formRef}
      display={display}
      isRequired={isRequired}
      refreshData={refreshPayment}
      onDataRefreshed={onDataRefreshed}
      onChangeCountryState={onChangeCountryState}
      card={card}
      errorsField={errorsField}
      loading={loadingBooking}
      setCard={(c) => dispatch(setCard(c))}
      displaySave={account?.isPrivateTokenAccountType || account?.isPrivateLoginAccountType}
      disableInsurance={!account?.enableInsurance || items?.isRemoveInsurance}
      multiplePayments={multiplePayments}
      setPaymentSelected={setPaymentSelected}
      paymentSelected={paymentSelected}
      handlePaymentFormValidation={handlePaymentFormValidation}
      handleCardSelect={handleCardSelect}
      scrollToPaymentSelect={scrollToPaymentSelect}
      scrollToPaymentSelectDisabled={scrollToPaymentSelectDisabled}
      availableNewFlow={true}
      isCars={false}
      stripeExpressCheckoutActive={stripeExpressCheckoutActive}
    />
  );
}
